import { FC } from 'react';
import { useState, useRef, useEffect } from 'react';
import Link from 'next/link';
import styles from './PageSort.module.scss';

interface IPageSort {
  sortingName?: string;
  url?: string;
}

const PageSort: FC<IPageSort> = ({ sortingName, url }) => {
  const [isActive, setIsActive] = useState(false);

  const filtersName = [
    { name: 'сначала новые', url: '' },
    { name: 'по рейтингу', url: 'sorting/rating' },
    { name: 'по просмотрам', url: 'sorting/visited' },
  ];

  const refFilterMenu = useRef<HTMLUListElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: Event) => {
      if (refFilterMenu.current && refFilterMenu.current.contains(event.target as HTMLElement)) {
        return;
      }
      setIsActive(false);
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  });

  const handleToggleActiveClass = () => {
    setIsActive(!isActive);
  };

  return (
    <div className={styles.pageSort}>
      <div className={styles.pageSort__filter}>
        <div className={styles.pageSort__txt}>Сортировка:</div>
        <ul onClick={handleToggleActiveClass} ref={refFilterMenu} className={`${styles.pageSort__list} ${isActive && styles.pageSort__list_active}`}>
          <li className={`${styles.pageSort__item} ${styles.pageSort__item_active}`}>{sortingName}</li>
          {filtersName.map((btn) => (
            <li key={btn.name} className={sortingName == btn.name ? `${styles.pageSort__item} ${styles.pageSort__item_none}` : `${styles.pageSort__item}`}>
              <Link prefetch={false} href={`${url}${btn.url}`}>
                {btn.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default PageSort;
